module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_is-object.js
// module id = 22
// module chunks = 0